import Input from '../../../components/ui/Input';
import { MONO_CLASS } from '../../../components/ui/Mono';
import Switch from '../../../components/ui/Switch';
import { BLING_LINK_STATUS_META, DEFAULT_LOW_STOCK_THRESHOLD } from '../../../constants/productCatalog';
import { FormatInt } from '../../../utils/format';
import { BlingLinkBadge, FieldCell, FieldInputProps, FormSection, ReadOnlyField } from '../editorParts';
import { FieldDomId } from '../productForm';

const WMS_PERMISSION_HINT = 'Requer Gerenciar produtos do armazém';

/**
 * Estoque e armazém: mínimo (vazio = 20), Volumoso e Rastreia lote (atributos
 * do WMS, `wms:manage:products`, gravados com o Salvar) e o saldo do Bling só
 * leitura — sem vínculo não há saldo vendável.
 */
const StockSection = ({ ctx, mode, product, canManageWms }) => {
    const { form, setField, readOnly } = ctx;
    const blingStatus = mode === 'new' ? 'NOT_LINKED' : product?.bling_status;
    const stockBling = product?.stock?.bling;
    const wmsDisabled = readOnly || !canManageWms;

    let saldo;
    if (blingStatus === 'NOT_LINKED' || stockBling === null || stockBling === undefined) {
        saldo = <span className="text-mono-500 dark:text-mono-400">sem vínculo</span>;
    } else {
        saldo = <span className={MONO_CLASS}>{FormatInt(stockBling)}</span>;
    }

    return (
        <FormSection
            id="estoque"
            title="Estoque e armazém"
            description="O saldo vendável vem do Bling; os atributos do armazém valem para o WMS."
        >
            <FieldCell span={2}>
                <Input
                    label="Estoque mínimo"
                    inputMode="numeric"
                    placeholder={`${DEFAULT_LOW_STOCK_THRESHOLD} (padrão)`}
                    autoComplete="off"
                    className={MONO_CLASS}
                    {...FieldInputProps(ctx, 'low_stock_threshold', { hint: 'Alerta de estoque baixo; vazio = 20' })}
                />
            </FieldCell>
            <FieldCell span={2}>
                <ReadOnlyField
                    label="Saldo Bling"
                    value={
                        <span className="flex w-full items-center justify-between gap-2">
                            {saldo}
                            <BlingLinkBadge status={blingStatus} blingId={product?.bling_id} compact />
                        </span>
                    }
                    hint={BLING_LINK_STATUS_META[blingStatus]?.help}
                />
            </FieldCell>
            <FieldCell span={2}>
                <ReadOnlyField
                    label="Saldo total"
                    value={
                        product?.stock?.total_quantity === null || product?.stock?.total_quantity === undefined ? (
                            <span className="text-mono-500 dark:text-mono-400">—</span>
                        ) : (
                            <span className={MONO_CLASS}>{FormatInt(product.stock.total_quantity)}</span>
                        )
                    }
                />
            </FieldCell>
            <FieldCell span={3}>
                <Switch
                    id={FieldDomId('is_bulky')}
                    checked={form.is_bulky}
                    onCheckedChange={(on) => setField('is_bulky', on)}
                    disabled={wmsDisabled}
                    label="Volumoso"
                    description="Pallet volumoso: exige vão de 2,50 m (trava passiva do WMS)."
                    title={!canManageWms ? WMS_PERMISSION_HINT : undefined}
                />
            </FieldCell>
            <FieldCell span={3}>
                <Switch
                    id={FieldDomId('track_supplier_lot')}
                    checked={form.track_supplier_lot}
                    onCheckedChange={(on) => setField('track_supplier_lot', on)}
                    disabled={wmsDisabled}
                    label="Rastreia lote"
                    description="Exige bipar o lote do fornecedor no consumo (produção)."
                    title={!canManageWms ? WMS_PERMISSION_HINT : undefined}
                />
            </FieldCell>
        </FormSection>
    );
};

export default StockSection;
